<template>
    <div class="d-flex align-items-center categories-auto-selection-panel mb-3">
        <div class="d-flex align-items-center categories-auto-selection-panel__label">
            <AppCheckbox :model-value="allSelected" class="mr-2" @update:model-value="$emit('toggle-all')" />
            <span class="font-weight-semibold">{{ $t('labels.create_integration_products_auto_selection_label') }}:</span>
        </div>
        <div class="d-flex categories-auto-selection-panel__modes">
            <button
                type="button"
                class="btn btn-sm rounded-pill categories-auto-selection-panel__mode-btn"
                :class="modes.includes('exact') ? 'btn-primary' : 'btn-light'"
                :disabled="isProcessing"
                @click="$emit('toggle-mode', 'exact')"
            >
                <i class="icon-checkmark3"></i>
                {{ $t('labels.create_integration_products_exact_match_mode') }}
            </button>
            <button
                type="button"
                class="btn btn-sm rounded-pill categories-auto-selection-panel__mode-btn"
                :class="modes.includes('ai') ? 'bg-violet' : 'btn-light'"
                :disabled="isProcessing || hasNoAiBalance"
                :title="hasNoAiBalance ? $t('alerts.insufficient_ai_balance') : ''"
                @click="$emit('toggle-mode', 'ai')"
            >
                <i class="icon-magic-wand2"></i>
                {{ $t('labels.create_integration_products_ai_match_mode') }}
            </button>
        </div>
        <button
            type="button"
            class="btn btn-primary ml-auto categories-auto-selection-panel__select-btn"
            :disabled="isProcessing || modes.length === 0 || selectedCount === 0"
            @click="$emit('submit')"
        >
            <i v-if="isProcessing" class="icon-spinner4 spinner mr-1"></i>
            <i v-else class="icon-magic-wand2 mr-1"></i>
            {{ $t('labels.create_integration_products_match_button') }}
        </button>
    </div>
</template>
<script>
import AppCheckbox from '../../../../components/new/form/checkbox/AppCheckbox.vue';

export default {
    name: 'CategoriesAutoSelectionPanel',
    components: {
        AppCheckbox
    },
    props: {
        allSelected: {
            type: Boolean,
            default: false
        },
        modes: {
            type: Array,
            default: () => []
        },
        isProcessing: {
            type: Boolean,
            default: false
        },
        hasNoAiBalance: {
            type: Boolean,
            default: false
        },
        selectedCount: {
            type: Number,
            default: 0
        },
    },
    emits: ['toggle-all', 'toggle-mode', 'submit'],
}
</script>
<style scoped>
.categories-auto-selection-panel {
    gap: 1rem;
    padding: .75rem 1rem;
    background: #eff6ff;
    border: 1px solid #e5e7eb;
    border-radius: .35rem;
}

.categories-auto-selection-panel__modes {
    gap: .5rem;
}

.categories-auto-selection-panel__mode-btn i {
    margin-right: .35rem;
}
</style>
